import { render, staticRenderFns } from "./ShopLinks.vue?vue&type=template&id=1b430662&scoped=true&"
import script from "./ShopLinks.vue?vue&type=script&lang=js&"
export * from "./ShopLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b430662",
  null
  
)

export default component.exports